module.exports = __webpack_public_path__ + "img/r-2-btn.fcc31f57.png";